import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Browser } from '@capacitor/browser';
import { AdsService } from 'src/app/services/ads/ads.service';
import { SubSink } from 'subsink';
import { PlatformService } from 'src/app/services/platform/platform.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
  s3_url: string = environment.s3_bucket_url;

  allowOver21Ads: boolean = false;

  ad_images: any;

  subscription = new SubSink();

  isiOSApp: boolean;

  constructor(
    private http: HttpClient,
    private adsService: AdsService,
    private platform: PlatformService
  ) {
    this.isiOSApp = this.platform.isiOSApp();
  }

  ngOnInit() {
    console.log("footer init");

    if (this.isiOSApp) {
      this.getStoredAgeStorageValue();
    } else {
      this.getStoredCookieValue();
    }

    // this.getFilteredAd();
    let positions_arr = ['bottom'];
    this.subscription.sink = this.adsService._adsStatus.subscribe((value) => {
      if (this.hasStoredAgeStorageValue() || this.getCookie('allowOver21Ads')) {
        console.log("footer ads");
        let data = {
          positions: positions_arr,
          allowOver21Ads: this.isiOSApp ? this.getStoredAgeStorageValue() : this.getStoredCookieValue()
        }
        this.http.post(`${environment.base_url}ads/filter-ads`, data)
        .subscribe(
          (res: any) => {
            // console.log("response =====> ",res.data.ad_images);
            this.ad_images = res.data.ad_images;
            // console.log("length ==> ",this.ad_images.length);
          },
          (err: any) => {
            console.log(err);
          }
        );
      }


    });
  }

  ionViewDidLeave(){
    console.log("footer did leave");

  }

  ngOnDestroy() {
    console.log("footer destroyed");
  }

  getStoredCookieValue(): boolean {
    // console.log("stored cookie ==> ",this.getCookie('allowOver21Ads'));
    let stored_cookie = this.getCookie('allowOver21Ads');
    if (stored_cookie == 'true')
      return this.allowOver21Ads = true;
    else
      return this.allowOver21Ads = false;
  }

  getStoredAgeStorageValue(): boolean {
    return JSON.parse(localStorage.getItem('allowOver21Ads'));
  }

  // getFilteredAd() {
  //   console.log("In filter ad function");
  //   let positions_arr = ['bottom'];
  //   this.subscription.sink = this.adsService._adsStatus.subscribe((value) => {
  //     if (this.getCookie('allowOver21Ads')) {
  //       console.log("footer ads");
  //       let data = {
  //         positions: positions_arr,
  //         allowOver21Ads: this.getStoredCookieValue()
  //       }
  //       this.http.post(`${environment.base_url}ads/filter-ads`, data)
  //       .subscribe(
  //         (res: any) => {
  //           // console.log("response =====> ",res.data.ad_images);
  //           this.ad_images = res.data.ad_images;
  //           // console.log("length ==> ",this.ad_images.length);
  //         },
  //         (err: any) => {
  //           console.log(err);
  //         }
  //       );
  //     }


  //   });

  // }

  getCookie(c_name) {
    if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        let c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1)
          c_end = document.cookie.length;
        // console.log("cookie ===> ",unescape(document.cookie.substring(c_start, c_end)));
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  }

  hasStoredAgeStorageValue(): boolean {
    let ageStorageKey = JSON.parse(localStorage.getItem('allowOver21Ads'));
    if (ageStorageKey === undefined || ageStorageKey === null) {
      return false;
    } else {
      return true;
    }
  }

  async redirectToURL(url) {
    // console.log("url ===> ",url);
    if(url.length > 0) {
      await Browser.open({ url: url });
    }
  }

}
